import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pageTitle" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_4 = { class: "buttonsSelector" }
const _hoisted_5 = { class: "buttonsTitle" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "midTitle" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "midTitle" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_dati_base_user = _resolveComponent("dati-base-user")!
  const _component_dati_lead = _resolveComponent("dati-lead")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: "Dettaglio lead:",
            text: "Dettaglio lead:"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.user.personalData.name) + " " + _toDisplayString(_ctx.user.personalData.surname), 1)
        ]),
        (_ctx.user.identifier)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.promote && _ctx.promote(...args)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Promuovi a cliente",
                  text: "Promuovi a cliente"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_localized_text, {
              localizedKey: "Visualizza",
              text: "Visualizza"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["button", { selected: _ctx.showAs == 'DatiBase' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAs = 'DatiBase'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Dati base",
                text: "Dati base"
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["button", { selected: _ctx.showAs == 'Lead' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAs = 'Lead'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Lead",
                text: "Lead"
              })
            ], 2)
          ])
        ]),
        (_ctx.showAs == 'DatiBase')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati base",
                  text: "Dati base"
                })
              ]),
              _hoisted_8,
              _createVNode(_component_dati_base_user, {
                user: _ctx.user,
                roles: _ctx.rolesList
              }, null, 8, ["user", "roles"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.showAs == 'Lead')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati lead",
                  text: "Dati lead"
                })
              ]),
              _hoisted_10,
              _createVNode(_component_dati_lead, { user: _ctx.user }, null, 8, ["user"])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mb-5",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Salva",
              text: "Salva"
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}